// extracted by mini-css-extract-plugin
export default {"cardContent":"styles_cardContent__oegKu"};